import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthGuard from "@/components/layout/AuthGuard";
import Index from "@/pages/Index";
import Overview from "@/pages/Overview";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Companies from "@/pages/Companies";
import CreateCompany from "@/pages/CreateCompany";
import EditCompany from "@/pages/EditCompany";
import Places from "@/pages/Places";
import CreatePlace from "@/pages/CreatePlace";
import EditPlace from "@/pages/EditPlace";
import Assets from "@/pages/Assets";
import CreateAsset from "@/pages/CreateAsset";
import EditAsset from "@/pages/EditAsset";
import AssetView from "@/pages/AssetView";
import Scan from "@/pages/Scan";
import PublicScan from "@/pages/PublicScan";
import ScanRedirect from "@/pages/ScanRedirect";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Records from "@/pages/Records";
import Profile from "@/pages/Profile";
import TivoTags from "@/pages/TivoTags";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/public/scan" element={<PublicScan />} />
          <Route path="/scan/:uid" element={<ScanRedirect />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route element={<AuthGuard />}>
            <Route path="/overview" element={<Overview />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/companies/new" element={<CreateCompany />} />
            <Route path="/companies/:id" element={<EditCompany />} />
            <Route path="/places" element={<Places />} />
            <Route path="/places/new" element={<CreatePlace />} />
            <Route path="/places/:id" element={<EditPlace />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/assets/new" element={<CreateAsset />} />
            <Route path="/assets/:id" element={<AssetView />} />
            <Route path="/assets/:id/edit" element={<EditAsset />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/records" element={<Records />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/tivo-tags" element={<TivoTags />} />
          </Route>
        </Routes>
        <Toaster />
      </Router>
  );
}

export default App;